import template from './collection.html';
import controller from './collection.controller';

let collectionComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default collectionComponent;
